module.exports = __webpack_public_path__ + "ga21-7d93c609.webp";